import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default function (params) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_ENERGEBASIC',
  });

  const manualRequest = function () {
    let url = '/api/energebasic';
    if (params && JSON.stringify(params) !== '{}') {
      Object.keys(params).forEach((key, index) => {
        if (index === 0) url += '?';
        else url += '&';
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
  };

  useEffect(() => {
    manualRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [data || {}, manualRequest];
}
